import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import YearBase, { YearBaseProps } from "@/components/ui/Form/Filters/components/Year/YearBase";

export interface YearControlledProps extends YearBaseProps {
  control: Control;
}
const YearControlled: FC<YearControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <YearBase field={field} fieldState={fieldState} {...rest} />;
};
export default YearControlled;
